import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'grantmaker-list-dialog',
  templateUrl: 'grantmaker-list-dialog.component.html',
  styleUrls: ['grantmaker-list-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GrantmakerListDialogComponent {
  isMobile: boolean;

  constructor(
    public dialogRef: MatDialogRef<GrantmakerListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall, Breakpoints.TabletPortrait]).subscribe((sz) => {
      this.isMobile = sz.matches;
    });
  }
}
